import { SoundType } from 'components/UI/LetterBlock/LetterBlock';

export function convertArray(array: SoundType[]) {
    const convertedArray = array?.map((input) => {
        if (input === 'consonant') return 'b';
        if (input === 'long-sound') return 'ge';
        if (input === 'short-sound') return 'gr';
        if (input.includes('special-sound')) return 'w';
        if (input === 'stupid-sound') return 'o';
        if (input === 'two-symbol-sound') return 'r';
        if (input === 'special-character-sound') return 'p';
        return '';
    }) as string[];

    return convertedArray;
}

export function deConvertArray(array: any[], reverse?: boolean) {
    const convertedArray = array?.map((input) => {
        if (input === 'b') return 'consonant';
        if (input === 'ge') return 'long-sound';
        if (input === 'gr') return 'short-sound';
        if (input === 'w') return 'special-sound';
        if (input === 'o') return 'stupid-sound';
        if (input === 'r') return 'two-symbol-sound';
        if (input === 'p') return 'special-character-sound';
        return '';
    }) as SoundType[];

    if (reverse) {
        const groupFiller = Array(5 - array.length).fill('');
        return [...groupFiller, ...convertedArray];
    }

    const filler = Array(10 - array.length).fill('');

    return [...convertedArray, ...filler];
}
